// Precision can be +/- integar
// rounding to 1000 precision === -3
// rounding the .0001 precision === 3
export default function round(number, precision) {
  const factor = 10 ** precision; // Math.pow
  const tmp = number * factor;
  const roundedTmp = Math.round(tmp);
  return roundedTmp / factor;
}



// WEBPACK FOOTER //
// ./app/utils/numeric/round.js